import { LabelColor } from 'src/components/Label';
import { apiClient } from 'src/careflow/ph-core/api_client/api_client';

type CarePlanStatusStatus = 'active' | 'inactive';

export interface CarePlanStatus {
  id: number;
  uuid: string;
  createdBy: string | null;
  createdOn: string | null;
  updatedBy: string | null;
  updatedOn: string | null;
  deletedOn: string | null;
  deletedBy: string | null;

  name: string;
  color: LabelColor;
  abbreviation: string;
  status: CarePlanStatusStatus;
  treatAsInactive: boolean;
}

export async function findCarePlanStatuses(filter?: any) {
  const query = new URLSearchParams(filter);
  const data = await apiClient.get<CarePlanStatus[]>(`/care-plan/statuses?${query}`);
  return data;
}

export async function getCarePlanStatus(id: string) {
  const data = await apiClient.get<CarePlanStatus>(`/care-plan/statuses/${id}`);
  return data;
}

export async function createCarePlanStatus(status: any) {
  const data = await apiClient.post<any,CarePlanStatus>(`/care-plan/statuses`, status);
  return data;
}

export async function updateCarePlanStatus(status: any) {
  const data = await apiClient.patch<any,CarePlanStatus>(`/care-plan/statuses/${status.uuid}`, status);
  return data;
}

export async function deleteCarePlanStatus(id: string) {
  const data = await apiClient.delete<any,CarePlanStatus>(`/care-plan/statuses/${id}`);
  return data;
}
